import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_session_form_field_username = _resolveComponent("session-form-field-username")!
  const _component_session_form_field_password = _resolveComponent("session-form-field-password")!
  const _component_q_spinner_oval = _resolveComponent("q-spinner-oval")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    ref: "form",
    class: "q-px-xl q-pt-xl q-gutter-y-md",
    onSubmit: _ctx.onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_session_form_field_username, {
        modelValue: _ctx.loginModel.username,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginModel.username) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_session_form_field_password, {
        modelValue: _ctx.loginModel.password,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginModel.password) = $event)),
        "show-icon": true
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        class: "full-width text-white",
        color: "secondary",
        label: "Sign In",
        size: "lg",
        type: "submit",
        unelevated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_inner_loading, { showing: _ctx.loginInProgress }, {
            default: _withCtx(() => [
              _createVNode(_component_q_spinner_oval, {
                color: "primary",
                size: "30px"
              })
            ]),
            _: 1
          }, 8, ["showing"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}